import styled from 'styled-components'

export const TableComponentCustorm = styled.div`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 10px 10px !important;
  }

  .ant-table-tbody > tr {
    background-color: white;
    transition: background-color 0.3s ease;
  }

  .ant-table-tbody > tr:hover {
    background-color: rgb(205, 218, 244);
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid rgb(204, 204, 204);
    border-left: 1px solid rgb(204, 204, 204);
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: 1px solid rgb(204, 204, 204);
  }

  .ant-table-thead tr:last-child {
    display: none;
  }

  .ant-table-thead {
    border-bottom: 0px;
  }

  .ant-table-thead > tr > th {
    border-bottom: 0px;
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }
    
`

export const TableDeppartmentComponentCustorm = styled.div`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 10px 10px !important;
  }

  .ant-table-tbody > tr {
    background-color: white;
    transition: background-color 0.3s ease;
  }

  .ant-table-tbody > tr:hover {
    background-color: rgb(205, 218, 244);
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid rgb(204, 204, 204);
    border-left: 1px solid rgb(204, 204, 204);
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: 1px solid rgb(204, 204, 204);
  }

  .ant-table-thead {
    border-bottom: 0px;
  }

  .ant-table-thead > tr > th {
    border-bottom: 0px;
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }
`

export const DangerouslyHTML = styled.div`
  white-space: normal; /* Cho phép xuống dòng */
  font-weight: normal;
`

export const CapitalizeString = styled.span`
  text-transform: capitalize;
`

export const CustomHistoryTable = styled.div`
    .even-group {
        background-color: rgb(235, 239, 247) !important;
    }

    .odd-group {
        background-color: #fff !important;
    }

    tr.even-group:hover td,
    tr.even-group td.ant-table-cell-row-hover {
        background-color: rgb(235, 239, 247) !important;
    }

    tr.odd-group:hover td,
    tr.odd-group td.ant-table-cell-row-hover {
        background-color: #fff !important;
    }
`;

